import { type Accessor, createEffect, createSignal, onCleanup } from "solid-js";

/** Returns a signal that lags `source` by `ms` after the last change. */
export function createDebouncedValue<T>(source: Accessor<T>, ms: number): Accessor<T> {
  const [value, setValue] = createSignal(source());

  createEffect(() => {
    const next = source();
    const timer = globalThis.setTimeout(() => setValue(() => next as T), ms);
    onCleanup(() => globalThis.clearTimeout(timer));
  });

  return value;
}
